import WebLayout from './ImageWidgetLayout.web';
import MobileLayout from './ImageWidgetLayout.web';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
